import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Services from "./components/Services";
import SolarPumps from "./components/SolarPumps";
import Sectors from "./components/Sectors";
import About from "./components/About";
import Suppliers from "./components/Suppliers";
import Gallery from "./components/Gallery";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import WhatsAppFloat from "./components/WhatsAppFloat";

function App() {
  return (
    <>
      {/* Salto de navegación para usuarios de teclado y lectores de pantalla */}
      <a
        href="#contenido"
        className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[70] focus:rounded-lg focus:bg-campo-700 focus:px-4 focus:py-2 focus:text-sm focus:font-semibold focus:text-white"
      >
        Saltar al contenido
      </a>

      <Navbar />

      <main id="contenido">
        <Hero />
        <Services />
        <SolarPumps />
        <Sectors />
        <About />
        <Suppliers />
        <Gallery />
        <Contact />
      </main>

      <Footer />
      <WhatsAppFloat />
    </>
  );
}

export default App;
